<template>
    <figure class="image is-1by1" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
        <div onclick="window.open('https://www.finbc.de', '_blank')" class="pointer-hand">
            <img src="/img/referenzen-finbc.png" alt="finbc GmbH">
        </div>
    </figure>
</template>

<script>
    export default {
        name: 'Referenzen-Kunden-3',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
